import InfoIcon from '@mui/icons-material/Info';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { useState } from 'react';

import CancelButton from '@/components/atoms/CancelButton';

export const SurveyUrlInfoButton = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <InputAdornment position="end">
        <Tooltip title="アンケートURL">
          <IconButton onClick={() => setOpen(true)}>
            <InfoIcon />
          </IconButton>
        </Tooltip>
      </InputAdornment>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>アンケートURL</DialogTitle>
        <DialogContent>
          <Stack spacing={1} my={2}>
            <Typography>
              ルーム退出後にアンケート画面へ遷移させたい場合はこちらに遷移先のURLを入力してください。全ルーム共通です。
            </Typography>
          </Stack>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center' }}>
          <CancelButton onClick={() => setOpen(false)} />
        </DialogActions>
      </Dialog>
    </>
  );
};
